export default {
  home: {
    metaTitle: "USFans Spreadsheet – Guide, avis et ressources",
    metaDescription: "Explorez le tableur USFans : ressources de créateurs, avis, informations de livraison, coupons, guides de sécurité, comparatifs et conseils pratiques.",
    hero: {
      badge: "Ressource indépendante · Mise à jour régulièrement",
      title: "USFans Spreadsheet — Votre centre de ressources USFans complet",
      subtitle: "Trouvez de meilleures informations grâce au tableur USFans. Explorez les ressources, les informations sur les créateurs, les avis, les guides de livraison, les coupons, les détails d'entrepôt, les conseils de sécurité et les tutoriels pratiques — le tout organisé dans un seul espace facile à utiliser.",
      primaryCta: "Explorer le tableur USFans",
      secondaryCta: "Acheter maintenant",
      trust: "Ressource indépendante · Guides faciles à parcourir · Mise à jour régulièrement",
    },
    what: {
      title: "Qu'est-ce que le tableur USFans ?",
      p1: "Le tableur USFans est une ressource structurée conçue pour rendre les informations liées à USFans plus faciles à découvrir, comparer et comprendre. Au lieu de chercher parmi des pages éparpillées, vous pouvez explorer des guides organisés, des ressources de créateurs, des détails de livraison, des avis et des recommandations de sécurité en un seul endroit.",
      p2: "Comme le tableur regroupe les informations par catégorie, il vous aide à passer rapidement d'une recherche générale à un produit ou créateur précis, sans sauter entre des dizaines de pages sans rapport.",
      cta: "Explorer le centre du tableur",
    },
    features: {
      title: "Tout ce que vous devez savoir sur USFans",
      subtitle: "Un aperçu rapide des sujets les plus utiles autour du tableur USFans.",
      spreadsheet: { title: "Tableur USFans", desc: "Explorez la ressource centrale du tableur et les informations associées." },
      review: { title: "Avis USFans", desc: "Comprenez les fonctions clés, les avantages, les limites et les considérations des utilisateurs." },
      shipping: { title: "Frais de livraison USFans", desc: "Découvrez ce qui influence les prix de livraison et comment comparer les options." },
      coupon: { title: "Coupon USFans", desc: "Trouvez des informations sur les promotions et le fonctionnement des coupons." },
      discount: { title: "Code promo USFans", desc: "Apprenez à vérifier les informations de remise avant d'utiliser un code." },
      warehouse: { title: "Entrepôt USFans", desc: "Comprenez l'entrepôt, le stockage et la préparation des commandes." },
      legit: { title: "USFans est-il fiable ?", desc: "Apprenez à évaluer la légitimité, la confiance et la sécurité." },
      safety: { title: "Sécurité USFans", desc: "Suivez des recommandations pratiques de confidentialité, de compte et de navigation." },
    },
    popular: {
      title: "Commencez par le guide complet",
      subtitle: "Notre guide détaillé explique ce qu'est le tableur USFans, pourquoi il compte et comment l'utiliser.",
      cta: "Lire le guide complet",
    },
    faqSection: {
      title: "Questions fréquentes",
      items: [
        { q: "Qu'est-ce que le tableur USFans ?", a: "C'est une ressource structurée qui organise les informations USFans — créateurs, catégories, livraison et plus — dans un centre facile à parcourir." },
        { q: "La consultation du tableur USFans est-elle gratuite ?", a: "La consultation des guides et des catégories est gratuite. Les achats se font sur la boutique principale." },
        { q: "Comment trouver un produit précis ?", a: "Utilisez la liste des catégories de cette page pour accéder directement à la section correspondante de la boutique principale." },
        { q: "USFans est-il fiable ?", a: "Vérifiez toujours les informations auprès des sources officielles et consultez les politiques de la boutique avant d'acheter." },
      ],
    },
    finalCta: {
      title: "Prêt à explorer toute la boutique ?",
      subtitle: "Accédez directement au site principal pour parcourir toutes les catégories et tous les produits.",
      primary: "Visiter le site principal",
      secondary: "Acheter maintenant",
    },
  },
};